import { render, staticRenderFns } from "./Blogs.vue?vue&type=template&id=f529ccb8&scoped=true&"
import script from "./Blogs.vue?vue&type=script&lang=js&"
export * from "./Blogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f529ccb8",
  null
  
)

component.options.__file = "Blogs.vue"
export default component.exports